import { createElement } from "react"
import type { FC, ReactElement } from "react"

import { type NavigateFunction, useNavigate } from "react-router-dom"
import { useMount } from "react-use"

import { RootLoaderFallback } from "@/3514/components"
import { EPath } from "@/3514/constants"

import { ELegacyOnboardingStepUrls as ELegacyStepUrl } from "./constants"

const routesMap = {
    [ELegacyStepUrl.PROFILE]: EPath.Participant_OnboardingProfile(),
    [ELegacyStepUrl.VIDEO_STEP]: EPath.Participant_OnboardingVideo(),
    [ELegacyStepUrl.MODULE_LIST_STEP]: EPath.Participant_OnboardingModules_Legacy(),
    [ELegacyStepUrl.DIAGNOSTIC_STEP]: EPath.Participant_OnboardingDiagnostic(),
    [ELegacyStepUrl.DIAGNOSTIC_RESPONSE_STEPS]: EPath.Participant_OnboardingDiagnosticResults_Legacy(),
    [ELegacyStepUrl.REFLECTION_OBJECTIVE_STEP]: EPath.Participant_OnboardingReflection(),
    [ELegacyStepUrl.SESSION_HOLD_TIMES_STEP]: EPath.Participant_OnboardingHolds(),
    [ELegacyStepUrl.COACH_SELECT_STEP]: EPath.Participant_OnboardingCoach()
}

type TPageBuilderProps = { step: ELegacyStepUrl }
function PageBuilder({ step }: TPageBuilderProps): ReactElement {
    const navigate: NavigateFunction = useNavigate()

    useMount((): void => {
        navigate(routesMap[step], { replace: true })
    })

    return createElement(RootLoaderFallback)
}

/**
 * @deprecated backward compatibility short-term support only, just re-navigates to appropriate page
 */
const LegacyOnboardingCoachPage: FC = (): ReactElement =>
        createElement(PageBuilder, { step: ELegacyStepUrl.COACH_SELECT_STEP }),
    /**
     * @deprecated backward compatibility short-term support only, just re-navigates to appropriate page
     */
    LegacyOnboardingDiagnosticPage: FC = (): ReactElement =>
        createElement(PageBuilder, { step: ELegacyStepUrl.DIAGNOSTIC_STEP }),
    /**
     * @deprecated backward compatibility short-term support only, just re-navigates to appropriate page
     */
    LegacyOnboardingDiagnosticResultsPage: FC = (): ReactElement =>
        createElement(PageBuilder, { step: ELegacyStepUrl.DIAGNOSTIC_RESPONSE_STEPS }),
    /**
     * @deprecated backward compatibility short-term support only, just re-navigates to appropriate page
     */
    LegacyOnboardingHoldsPage: FC = (): ReactElement =>
        createElement(PageBuilder, { step: ELegacyStepUrl.SESSION_HOLD_TIMES_STEP }),
    /**
     * @deprecated backward compatibility short-term support only, just re-navigates to appropriate page
     */
    LegacyOnboardingModulesPage: FC = (): ReactElement =>
        createElement(PageBuilder, { step: ELegacyStepUrl.MODULE_LIST_STEP }),
    /**
     * @deprecated backward compatibility short-term support only, just re-navigates to appropriate page
     */
    LegacyOnboardingProfilePage: FC = (): ReactElement => createElement(PageBuilder, { step: ELegacyStepUrl.PROFILE }),
    /**
     * @deprecated backward compatibility short-term support only, just re-navigates to appropriate page
     */
    LegacyOnboardingReflectionPage: FC = (): ReactElement =>
        createElement(PageBuilder, { step: ELegacyStepUrl.REFLECTION_OBJECTIVE_STEP }),
    /**
     * @deprecated backward compatibility short-term support only, just re-navigates to appropriate page
     */
    LegacyOnboardingVideoPage: FC = (): ReactElement => createElement(PageBuilder, { step: ELegacyStepUrl.VIDEO_STEP })

export {
    LegacyOnboardingCoachPage,
    LegacyOnboardingDiagnosticPage,
    LegacyOnboardingDiagnosticResultsPage,
    LegacyOnboardingHoldsPage,
    LegacyOnboardingModulesPage,
    LegacyOnboardingProfilePage,
    LegacyOnboardingReflectionPage,
    LegacyOnboardingVideoPage
}
